import RepositorySelectGroup from './Container'
export default RepositorySelectGroup


// WEBPACK FOOTER //
// ./src/modules/RepositorySelect/index.js